import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from '../';
import { IBaseResponse, IInvoiceTransplants } from '@nkr/models/index';
import { InvoiceTransplantStatus, OrganType } from '@nkr/enums/index';

export interface IInvoiceTransplantListResponse {
    data: {
        success: boolean,
        results: IInvoiceTransplants[]
    }
}

export interface IInvoiceTransplantRequest {
    invoiceYear: string,
    invoiceMonth: string,
    transplantType: InvoiceTransplantStatus,
    organType: OrganType
}

export const ActionCreators = {
    getInvoiceList: (invoiceRequest: IInvoiceTransplantRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IInvoiceTransplantListResponse> => {
        let { invoiceMonth, invoiceYear, transplantType, organType } = invoiceRequest;

        let options = {
            url: __API__ + `/invoice/index?InvoiceYear=${invoiceYear}&InvoiceMonth=${invoiceMonth}&OrganType=${organType}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    generateInvoiceByCenter: (centerId: number, invoiceDate: string, organType?: number, filteredOrganType?: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IInvoiceTransplantListResponse> => {
        let options = {
            url: __API__ + `/invoice/${invoiceDate}/center/${centerId}/generate?organType=${organType}&filteredOrganType=${filteredOrganType}`
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    generateInvoicePreviewByCenter: (centerId: number, invoiceDate: string, organType?: number, filteredOrganType?: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IInvoiceTransplantListResponse> => {
        let options = {
            url: __API__ + `/invoice/${invoiceDate}/center/${centerId}/generate-preview?organType=${organType}&filteredOrganType=${filteredOrganType}`
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    previewInvoice: (centerId: number, invoiceDate: string, organType?: number) => (dispatch: Dispatch<IApplicationState>) => {
        let options = {
            url: `${__API__}/invoice/${invoiceDate}/center/${centerId}/preview${organType != null ? `?organType=${organType}` : ''}`,
            responseType: 'blob'
        }

        return dispatch(AuthActionCreators.apiGet(options));
    },
    viewInvoice: (invoiceNumber: number) => (dispatch: Dispatch<IApplicationState>) => {
        let options = {
            url: `${__API__}/invoice/${invoiceNumber}`,
            responseType: 'blob'
        }

        return dispatch(AuthActionCreators.apiGet(options));
    },
    regenerateInvoice: (invoiceNumber: number, organType: number) => (dispatch: Dispatch<IApplicationState>) => {
        let options = {
            url: `${__API__}/invoice/${invoiceNumber}/regenerate?organType=${organType}`,
            responseType: 'blob'
        }

        return dispatch(AuthActionCreators.apiGet(options));
    },
    downloadAll: (invoiceDate: string, invoiceNumbers: number[]) => (dispatch: Dispatch<IApplicationState>) => {
        let options = {
            url: `${__API__}/invoice/${invoiceDate}/download`,
            data: { invoiceNumbers: invoiceNumbers.map(Number) },
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiPost(options));
    },
    downloadAllPreviews: (invoiceDate: string, centers: { centerId: number, organType: number }[]) => (dispatch: Dispatch<IApplicationState>) => {
        let options = {
            url: `${__API__}/invoice/${invoiceDate}/download-preview`,
            data: { centers },
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiPost(options));
    },

    bulkInvoiceSend: (invoiceNumbers: number[], invoiceRequest: IInvoiceTransplantRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let invoiceDate = `${invoiceRequest.invoiceYear}-${String(invoiceRequest.invoiceMonth).padStart(2, '0')}-01`;
        let transplantType = invoiceRequest.transplantType;

        let options = {
            url: `${__API__}/invoice/batch-send-invoice`,
            data: {
                invoiceNumbers: invoiceNumbers.map(Number),
                invoiceDate,
                transplantType: Number(transplantType)
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    }
};
